import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { LOADER_TYPE, LoaderType } from '../services/loader.modal';
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  loaderService = inject(LoaderService);

  private requests: { type: LoaderType }[] = [];

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const loaderType = req.context.get(LOADER_TYPE);
    if (loaderType !== 'none') {
      this.requests.push({ type: loaderType });
      this.loaderService.setLoader(loaderType);
    }
    return next.handle(req).pipe(
      finalize(() => {
        if (loaderType !== 'none') {
          this.requests.pop();
          if (this.requests.length === 0) {
            this.loaderService.clear();
          } else {
            this.loaderService.setLoader(
              this.requests[this.requests.length - 1].type
            );
          }
        }
      })
    );
  }
}
